import { Card } from "primereact/card";
import { IServiceCard } from "../types/IServiceCard";
import Plot from "react-plotly.js";
import { useEffect, useState } from "react";
import { IFleetAppPerformance } from "../types/IFleetAppPerformance";
import { GetFleetAppPerformance } from "../services/GetFleetAppPerformance";
import { getSectionColour } from "../utils/utils";

const PlotComponent = Plot as any;

/**
 * Fleet Performance card component
 */
export const FleetPerformanceCard = ({ serviceGroup }: IServiceCard) => {
    const [performanceData, setPerformanceData] = useState<IFleetAppPerformance[]>([]);

    useEffect(() => {
        getData();
        async function getData() {
            try {
                const data = await GetFleetAppPerformance();
                setPerformanceData(data);
            } catch (error) {
                console.error('Failed to fetch performance data:', error);
            }
        }
    }, []);

    const processPerformanceData = (serviceType: 'warm' | 'cold') => {
        const filteredData = performanceData.filter(item => item.service === serviceType);
        
        const groupedData = filteredData.reduce((acc, item) => {
            if (!acc[item.section]) {
                acc[item.section] = [];
            }
            acc[item.section].push(item);
            return acc;
        }, {} as { [key: string]: IFleetAppPerformance[] });

        return Object.entries(groupedData).map(([section, data]) => {
            const dailyData = data.reduce((acc, item) => {
                const date = new Date(item.timestamp).toDateString();
                if (!acc[date] || item.timestamp > acc[date].timestamp) {
                    acc[date] = item;
                }
                return acc;
            }, {} as { [key: string]: IFleetAppPerformance });
            
            const sortedData = Object.values(dailyData).sort((a, b) => a.timestamp - b.timestamp);
            return {
                x: sortedData.map(item => new Date(item.timestamp)),
                y: sortedData.map(item => item.loadTime),
                type: 'scatter',
                mode: 'lines',
                name: section,
                line: { color: getSectionColour(section) }
            };
        });
    };

    return (
        <>
            <Card
                className="service-card cursor-pointer h-full mt-4"
                title={`${serviceGroup.name} (Warm)`}
            >
                <PlotComponent
                    data={processPerformanceData('warm')}
                    layout={{
                        height: 480,
                        paper_bgcolor: '#1e1e1e',
                        plot_bgcolor: '#2d2d2d',
                        font: { color: '#ffffff' },
                        xaxis: { gridcolor: '#444444', color: '#ffffff', title: 'Date', type: 'date', tickformat: '%d/%m/%Y' },
                        yaxis: { gridcolor: '#444444', color: '#ffffff', title: 'Load Time (ms)', tickformat: '.0f' },
                        showlegend: true,
                        hovermode: 'closest'
                    }}
                    useResizeHandler={true}
                    style={{width: '100%'}}
                />
            </Card>
            <Card
                className="service-card cursor-pointer h-full mt-4"
                title={`${serviceGroup.name} (Cold Starts)`}
            >
                <PlotComponent
                    data={processPerformanceData('cold')}
                    layout={{
                        height: 480,
                        paper_bgcolor: '#1e1e1e',
                        plot_bgcolor: '#2d2d2d',
                        font: { color: '#ffffff' },
                        xaxis: { gridcolor: '#444444', color: '#ffffff', title: 'Date', type: 'date', tickformat: '%d/%m/%Y' },
                        yaxis: { gridcolor: '#444444', color: '#ffffff', title: 'Load Time (ms)', tickformat: '.0f' },
                        showlegend: true
                    }}
                    useResizeHandler={true}
                    style={{width: '100%'}}
                />
            </Card>
        </>
    );
};